export default __webpack_public_path__ + "static/media/automatskavrata10.286ceb37.jpg";